import { BRIDGE_METHODS } from '@/common/bridge/constants'
import { bridge } from '@/common/bridge/methods'
import { isInWeChatMiniProgram } from '@/utils/tool'
import { router } from '@/router'
import wx from 'weixin-js-sdk'

/**
 * 路由前缀
 * @type {Object}
 * @property {string} client 景点门票路由前缀
 * @property {string} newJourney 当前项目路由前缀
 */
const routePrefix = {
  client: '/#/commonModule/pages',
  newJourney: '/new-journey',
}

/**
 * 跳转flutter webview页面，支持push和go
 * @param {string} url 跳转的url，无需携带域名，如需参数，需要拼接在路由之后
 * @param {string} projectName 项目名称，client或newJourney
 * @param {string} type 跳转类型，push或go
 * @param {string} title 页面标题 必传，不传会丢失导航头
 * @param {string} [fullUrl] 完整的url，如果传递此参数，将忽略url和projectName参数，直接使用此完整url
 * @param {string} [cb] then callback
 * @returns {void} 无返回值
 */
export const NavigateToWebview = ({
  url,
  projectName = 'client',
  type = 'push',
  title,
  fullUrl,
  cb,
  hasHistory = true,
}) => {
  /**
   * 如果传递了完整URL，直接使用fullUrl，否则拼接routePrefix和url
   */
  let targetUrl
  if (fullUrl) {
    targetUrl = fullUrl
  } else {
    targetUrl = window.location.origin + routePrefix[projectName] + url
  }

  if (isInWeChatMiniProgram()) {
    const miniProgramUrl = `/pages/webview/index?url=${encodeURIComponent(targetUrl)}`
    try {
      wx?.miniProgram?.[hasHistory ? 'navigateTo' : 'redirectTo']({ url: miniProgramUrl })
    } catch (error) {
      console.error('小程序跳转失败:', error)
    }
    return
  }

  let name = `/web?url=${encodeURIComponent(targetUrl)}`
  if (title) {
    name += `&title=${title}`
  }
  if (hasHistory) {
    // hasHistory为true时，只执行OPEN_PAGE
    bridge
      .invokeSync(BRIDGE_METHODS.OPEN_PAGE, { type, name })
      .then(() => {
        console.log('跳转成功')
        cb && cb()
      })
      .catch(error => {
        console.error('跳转失败:', error)
      })
  } else {
    // hasHistory为false时，先执行ROUTER_POP，再执行OPEN_PAGE
    bridge
      .invokeSync(BRIDGE_METHODS.ROUTER_POP)
      .then(() => {
        return bridge.invokeSync(BRIDGE_METHODS.OPEN_PAGE, { type, name })
      })
      .then(() => {
        console.log('跳转成功')
        cb && cb()
      })
      .catch(error => {
        console.error('跳转失败:', error)
      })
  }
}
